import { DataContentType, IApi, IField, IResource } from '../types'

export const fieldDropdown = {
  '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
  gally: {
    input: 'select',
    options: {
      values: [
        { value: 'test1', label: 'option_test1' },
        { value: 'test2', label: 'option_test2' },
      ],
    },
    editable: false,
    position: 10,
    visible: true,
  },
  property: {
    '@id': 'https://localhost/docs.jsonld#SourceField/code',
    '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
    domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
    range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
    label: 'Attribute code',
  },
  readable: true,
  required: true,
  title: 'code',
  writeable: true,
} as IField

export const fieldDropdownWithContext = {
  '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
  gally: {
    input: 'select' as DataContentType,
    options: {
      values: [
        { value: 'test1', label: 'option_test1' },
        { value: 'test2', label: 'option_test2' },
      ],
    },
    editable: false,
    position: 10,
    visible: true,
    context: {
      search_configuration_attributes: {
        visible: false,
        position: 30,
      },
    },
  },
  property: {
    '@id': 'https://localhost/docs.jsonld#SourceField/code',
    '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
    domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
    range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
    label: 'Attribute code',
  },
  readable: true,
  required: true,
  title: 'code',
  writeable: true,
} as IField

export const fieldWithContextAndMainContext = {
  '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
  gally: {
    context: {
      search_configuration_attributes: {
        visible: true,
      },
    },
    editable: true,
    position: 60,
    visible: true,
    form: { visible: false },
  },
  property: {
    '@id': 'http://localhost:6006//docs.jsonld#SourceField/isSortable',
    '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
    domain: {
      '@id': 'http://localhost:6006//docs.jsonld#SourceField',
    },
    range: {
      '@id': 'http://www.w3.org/2001/XMLSchema#boolean',
    },
    label: 'Sortable',
  },
  readable: true,
  required: false,
  title: 'isSortable',
  writeable: true,
} as IField

export const fieldDropdownWithApiOptions = {
  '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
  gally: {
    input: 'select',
    options: {
      api_rest: '/product_sorting_options',
    },
    editable: false,
    position: 10,
    visible: true,
  },
  property: {
    '@id': 'https://localhost/docs.jsonld#SourceField/code',
    '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
    domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
    range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
    label: 'Attribute code',
  },
  readable: true,
  required: true,
  title: 'code',
  writeable: true,
} as IField

export const resources = [
  {
    '@id': 'https://localhost/docs.jsonld#Index',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of Index resources.',
        label: 'Retrieves the collection of Index resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Index' },
        method: 'POST',
        title: 'Creates a Index resource.',
        label: 'Creates a Index resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Index' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves Index resource.',
        label: 'Retrieves Index resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Index' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the Index resource.',
        label: 'Deletes the Index resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Index' },
        method: 'PUT',
        title: 'Replaces the Index resource.',
        label: 'Replaces the Index resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Index' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Index' },
        method: 'PUT',
        title: 'Replaces the Index resource.',
        label: 'Replaces the Index resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Index' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/aliases',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'aliases',
        },
        readable: true,
        required: false,
        title: 'aliases',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/docsCount',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'docsCount',
        },
        readable: true,
        required: false,
        title: 'docsCount',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/size',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'size',
        },
        readable: true,
        required: false,
        title: 'size',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/entityType',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'entityType',
        },
        readable: true,
        required: false,
        title: 'entityType',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/catalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          label: 'catalog',
        },
        readable: true,
        required: false,
        title: 'catalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Index/status',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Index' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'status',
        },
        readable: true,
        required: false,
        title: 'status',
        writeable: true,
      },
    ],
    title: 'Index',
    label: 'Index',
    url: 'https://localhost/indices',
  },
  {
    '@id': 'https://localhost/docs.jsonld#IndexDocument',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of IndexDocument resources.',
        label: 'Retrieves the collection of IndexDocument resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#IndexDocument' },
        method: 'POST',
        title: 'Creates a IndexDocument resource.',
        label: 'Creates a IndexDocument resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#IndexDocument' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves IndexDocument resource.',
        label: 'Retrieves IndexDocument resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#IndexDocument' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the IndexDocument resource.',
        label: 'Deletes the IndexDocument resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#IndexDocument/indexName',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#IndexDocument' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'indexName',
        },
        readable: true,
        required: false,
        title: 'indexName',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#IndexDocument/documents',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#IndexDocument' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'documents',
        },
        readable: true,
        required: false,
        title: 'documents',
        writeable: true,
      },
    ],
    title: 'IndexDocument',
    label: 'IndexDocument',
    url: 'https://localhost/index_documents',
  },
  {
    '@id': 'https://localhost/docs.jsonld#SourceFieldOption',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of SourceFieldOption resources.',
        label: 'Retrieves the collection of SourceFieldOption resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
        method: 'POST',
        title: 'Creates a SourceFieldOption resource.',
        label: 'Creates a SourceFieldOption resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves SourceFieldOption resource.',
        label: 'Retrieves SourceFieldOption resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
        method: 'PUT',
        title: 'Replaces the SourceFieldOption resource.',
        label: 'Replaces the SourceFieldOption resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
        method: 'PATCH',
        title: 'Updates the SourceFieldOption resource.',
        label: 'Updates the SourceFieldOption resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the SourceFieldOption resource.',
        label: 'Deletes the SourceFieldOption resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOption/sourceField',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          label: 'sourceField',
        },
        readable: true,
        required: true,
        title: 'sourceField',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOption/position',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'position',
        },
        readable: true,
        required: false,
        title: 'position',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOption/labels',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
          range: {
            '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
          },
          label: 'labels',
        },
        readable: true,
        required: false,
        title: 'labels',
        writeable: true,
      },
    ],
    title: 'SourceFieldOption',
    label: 'SourceFieldOption',
    url: 'https://localhost/source_field_options',
  },
  {
    '@id': 'https://localhost/docs.jsonld#SourceField',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of SourceField resources.',
        label: 'Retrieves the collection of SourceField resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceField' },
        method: 'POST',
        title: 'Creates a SourceField resource.',
        label: 'Creates a SourceField resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceField' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves SourceField resource.',
        label: 'Retrieves SourceField resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceField' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceField' },
        method: 'PUT',
        title: 'Replaces the SourceField resource.',
        label: 'Replaces the SourceField resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceField' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#SourceField' },
        method: 'PATCH',
        title: 'Updates the SourceField resource.',
        label: 'Updates the SourceField resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceField' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the SourceField resource.',
        label: 'Deletes the SourceField resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          editable: false,
          position: 10,
          visible: true,
          alias: 'code.alias',
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/code',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'Attribute code',
        },
        readable: true,
        required: true,
        title: 'code',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: { editable: false, position: 20, visible: true },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/defaultLabel',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'Attribute label',
        },
        readable: true,
        required: false,
        title: 'defaultLabel',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: false } },
          editable: false,
          position: 30,
          visible: true,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/type',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'Attribute type',
        },
        readable: true,
        required: false,
        title: 'type',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: false } },
          editable: true,
          position: 40,
          visible: true,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isFilterable',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'Filterable',
        },
        readable: true,
        required: false,
        title: 'isFilterable',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: false } },
          editable: true,
          position: 50,
          visible: true,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isSearchable',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'Searchable',
        },
        readable: true,
        required: false,
        title: 'isSearchable',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: false } },
          editable: true,
          position: 60,
          visible: true,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isSortable',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'Sortable',
        },
        readable: true,
        required: false,
        title: 'isSortable',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: false } },
          editable: true,
          position: 70,
          visible: true,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isUsedForRules',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'Use in rule engine',
        },
        readable: true,
        required: false,
        title: 'isUsedForRules',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: true } },
          editable: true,
          position: 80,
          visible: false,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/weight',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'Search weight',
        },
        readable: true,
        required: false,
        title: 'weight',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        gally: {
          context: { grid_2: { visible: true } },
          editable: true,
          position: 90,
          visible: false,
        },
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isSpellchecked',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'Used in spellcheck',
        },
        readable: true,
        required: false,
        title: 'isSpellchecked',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/isSystem',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'isSystem',
        },
        readable: true,
        required: false,
        title: 'isSystem',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/metadata',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#Metadata' },
          label: 'metadata',
        },
        readable: true,
        required: true,
        title: 'metadata',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/labels',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
          label: 'labels',
        },
        readable: true,
        required: false,
        title: 'labels',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceField/options',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          range: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
          label: 'options',
        },
        readable: true,
        required: false,
        title: 'options',
        writeable: true,
      },
    ],
    title: 'SourceField',
    label: 'SourceField',
    url: 'https://localhost/source_fields',
  },
  {
    '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of SourceFieldOptionLabel resources.',
        label: 'Retrieves the collection of SourceFieldOptionLabel resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
        method: 'POST',
        title: 'Creates a SourceFieldOptionLabel resource.',
        label: 'Creates a SourceFieldOptionLabel resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves SourceFieldOptionLabel resource.',
        label: 'Retrieves SourceFieldOptionLabel resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
        method: 'PUT',
        title: 'Replaces the SourceFieldOptionLabel resource.',
        label: 'Replaces the SourceFieldOptionLabel resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
        method: 'PATCH',
        title: 'Updates the SourceFieldOptionLabel resource.',
        label: 'Updates the SourceFieldOptionLabel resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the SourceFieldOptionLabel resource.',
        label: 'Deletes the SourceFieldOptionLabel resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#SourceFieldOptionLabel/sourceFieldOption',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: {
            '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
          },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#SourceFieldOption' },
          label: 'sourceFieldOption',
        },
        readable: true,
        required: true,
        title: 'sourceFieldOption',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel/catalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: {
            '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
          },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          label: 'catalog',
        },
        readable: true,
        required: true,
        title: 'catalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel/label',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#SourceFieldOptionLabel',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'label',
        },
        readable: true,
        required: true,
        title: 'label',
        writeable: true,
      },
    ],
    title: 'SourceFieldOptionLabel',
    label: 'SourceFieldOptionLabel',
    url: 'https://localhost/source_field_option_labels',
  },
  {
    '@id': 'https://localhost/docs.jsonld#Metadata',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of Metadata resources.',
        label: 'Retrieves the collection of Metadata resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Metadata' },
        method: 'POST',
        title: 'Creates a Metadata resource.',
        label: 'Creates a Metadata resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Metadata' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves Metadata resource.',
        label: 'Retrieves Metadata resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Metadata' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Metadata' },
        method: 'PUT',
        title: 'Replaces the Metadata resource.',
        label: 'Replaces the Metadata resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Metadata' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#Metadata' },
        method: 'PATCH',
        title: 'Updates the Metadata resource.',
        label: 'Updates the Metadata resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Metadata' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the Metadata resource.',
        label: 'Deletes the Metadata resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Metadata/entity',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Metadata' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'entity',
        },
        readable: true,
        required: true,
        title: 'entity',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Metadata/sourceFields',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#Metadata' },
          range: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          label: 'sourceFields',
        },
        readable: true,
        required: false,
        title: 'sourceFields',
        writeable: true,
      },
    ],
    title: 'Metadata',
    label: 'Metadata',
    url: 'https://localhost/metadata',
  },
  {
    '@id': 'https://localhost/docs.jsonld#SourceFieldLabel',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of SourceFieldLabel resources.',
        label: 'Retrieves the collection of SourceFieldLabel resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
        method: 'POST',
        title: 'Creates a SourceFieldLabel resource.',
        label: 'Creates a SourceFieldLabel resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves SourceFieldLabel resource.',
        label: 'Retrieves SourceFieldLabel resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
        method: 'PUT',
        title: 'Replaces the SourceFieldLabel resource.',
        label: 'Replaces the SourceFieldLabel resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
        method: 'PATCH',
        title: 'Updates the SourceFieldLabel resource.',
        label: 'Updates the SourceFieldLabel resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the SourceFieldLabel resource.',
        label: 'Deletes the SourceFieldLabel resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldLabel/sourceField',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          label: 'sourceField',
        },
        readable: true,
        required: true,
        title: 'sourceField',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldLabel/catalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          label: 'catalog',
        },
        readable: true,
        required: true,
        title: 'catalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#SourceFieldLabel/label',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#SourceFieldLabel' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'label',
        },
        readable: true,
        required: true,
        title: 'label',
        writeable: true,
      },
    ],
    title: 'SourceFieldLabel',
    label: 'SourceFieldLabel',
    url: 'https://localhost/source_field_labels',
  },
  {
    '@id': 'https://localhost/docs.jsonld#Catalog',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of Catalog resources.',
        label: 'Retrieves the collection of Catalog resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Catalog' },
        method: 'POST',
        title: 'Creates a Catalog resource.',
        label: 'Creates a Catalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Catalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves Catalog resource.',
        label: 'Retrieves Catalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Catalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Catalog' },
        method: 'PUT',
        title: 'Replaces the Catalog resource.',
        label: 'Replaces the Catalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Catalog' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#Catalog' },
        method: 'PATCH',
        title: 'Updates the Catalog resource.',
        label: 'Updates the Catalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Catalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the Catalog resource.',
        label: 'Deletes the Catalog resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Catalog/code',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Catalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'code',
        },
        readable: true,
        required: true,
        title: 'code',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Catalog/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Catalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Catalog/localizedCatalogs',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Catalog' },
          range: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          label: 'localizedCatalogs',
        },
        readable: true,
        required: false,
        title: 'localizedCatalogs',
        writeable: true,
      },
    ],
    title: 'Catalog',
    label: 'Catalog',
    url: 'https://localhost/catalogs',
  },
  {
    '@id': 'https://localhost/docs.jsonld#LocalizedCatalog',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of LocalizedCatalog resources.',
        label: 'Retrieves the collection of LocalizedCatalog resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
        method: 'POST',
        title: 'Creates a LocalizedCatalog resource.',
        label: 'Creates a LocalizedCatalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves LocalizedCatalog resource.',
        label: 'Retrieves LocalizedCatalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
        method: 'PUT',
        title: 'Replaces the LocalizedCatalog resource.',
        label: 'Replaces the LocalizedCatalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
        method: 'PATCH',
        title: 'Updates the LocalizedCatalog resource.',
        label: 'Updates the LocalizedCatalog resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the LocalizedCatalog resource.',
        label: 'Deletes the LocalizedCatalog resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/code',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'code',
        },
        readable: true,
        required: true,
        title: 'code',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/locale',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'locale',
        },
        readable: true,
        required: true,
        title: 'locale',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        description:
          "It's important to keep the getter for isDefault property,\notherwise Api Platform will be not able to get the value in the response,\nin other words don't rename by IsDefault().",
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/isDefault',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'isDefault',
        },
        readable: true,
        required: false,
        title: 'isDefault',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/catalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#Catalog' },
          label: 'catalog',
        },
        readable: true,
        required: true,
        title: 'catalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#LocalizedCatalog/localName',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'localName',
        },
        readable: true,
        required: false,
        title: 'localName',
        writeable: false,
      },
    ],
    title: 'LocalizedCatalog',
    label: 'LocalizedCatalog',
    url: 'https://localhost/localized_catalogs',
  },
  {
    '@id': 'https://localhost/docs.jsonld#FacetConfiguration',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of FacetConfiguration resources.',
        label: 'Retrieves the collection of FacetConfiguration resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves FacetConfiguration resource.',
        label: 'Retrieves FacetConfiguration resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
        method: 'PUT',
        title: 'Replaces the FacetConfiguration resource.',
        label: 'Replaces the FacetConfiguration resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
        method: 'PATCH',
        title: 'Updates the FacetConfiguration resource.',
        label: 'Updates the FacetConfiguration resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the FacetConfiguration resource.',
        label: 'Deletes the FacetConfiguration resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/sourceField',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#SourceField' },
          label: 'sourceField',
        },
        readable: true,
        required: true,
        title: 'sourceField',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/category',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#Category' },
          label: 'category',
        },
        readable: true,
        required: false,
        title: 'category',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/displayMode',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'displayMode',
        },
        readable: true,
        required: false,
        title: 'displayMode',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/coverageRate',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'coverageRate',
        },
        readable: true,
        required: false,
        title: 'coverageRate',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/maxSize',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'maxSize',
        },
        readable: true,
        required: false,
        title: 'maxSize',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/sortOrder',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'sortOrder',
        },
        readable: true,
        required: false,
        title: 'sortOrder',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/isRecommendable',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'isRecommendable',
        },
        readable: true,
        required: false,
        title: 'isRecommendable',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#FacetConfiguration/isVirtual',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'isVirtual',
        },
        readable: true,
        required: false,
        title: 'isVirtual',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultDisplayMode',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'defaultDisplayMode',
        },
        readable: true,
        required: false,
        title: 'defaultDisplayMode',
        writeable: false,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultCoverageRate',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'defaultCoverageRate',
        },
        readable: true,
        required: false,
        title: 'defaultCoverageRate',
        writeable: false,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultMaxSize',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'defaultMaxSize',
        },
        readable: true,
        required: false,
        title: 'defaultMaxSize',
        writeable: false,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultSortOrder',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'defaultSortOrder',
        },
        readable: true,
        required: false,
        title: 'defaultSortOrder',
        writeable: false,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultIsRecommendable',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'defaultIsRecommendable',
        },
        readable: true,
        required: false,
        title: 'defaultIsRecommendable',
        writeable: false,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#FacetConfiguration/defaultIsVirtual',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#FacetConfiguration' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'defaultIsVirtual',
        },
        readable: true,
        required: false,
        title: 'defaultIsVirtual',
        writeable: false,
      },
    ],
    title: 'FacetConfiguration',
    label: 'FacetConfiguration',
    url: 'https://localhost/facet_configurations',
  },
  {
    '@id': 'https://localhost/docs.jsonld#Category',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of Category resources.',
        label: 'Retrieves the collection of Category resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Category' },
        method: 'POST',
        title: 'Creates a Category resource.',
        label: 'Creates a Category resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Category' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves Category resource.',
        label: 'Retrieves Category resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Category' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#Category' },
        method: 'PUT',
        title: 'Replaces the Category resource.',
        label: 'Replaces the Category resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Category' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#Category' },
        method: 'PATCH',
        title: 'Updates the Category resource.',
        label: 'Updates the Category resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#Category' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the Category resource.',
        label: 'Deletes the Category resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Category/id',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Category' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'id',
        },
        readable: true,
        required: false,
        title: 'id',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Category/parentId',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Category' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'parentId',
        },
        readable: true,
        required: false,
        title: 'parentId',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Category/level',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Category' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#integer' },
          label: 'level',
        },
        readable: true,
        required: false,
        title: 'level',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#Category/path',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#Category' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'path',
        },
        readable: true,
        required: false,
        title: 'path',
        writeable: true,
      },
    ],
    title: 'Category',
    label: 'Category',
    url: 'https://localhost/categories',
  },
  {
    '@id': 'https://localhost/docs.jsonld#ProductSortingOption',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: {
      '@type': [
        'http://www.w3.org/ns/hydra/core#Operation',
        'http://schema.org/FindAction',
      ],
      method: 'GET',
      title: 'Retrieves the collection of ProductSortingOption resources.',
      label: 'Retrieves the collection of ProductSortingOption resources.',
      returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
    },
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ProductSortingOption/label',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#ProductSortingOption',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'label',
        },
        readable: true,
        required: false,
        title: 'label',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ProductSortingOption/code',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#ProductSortingOption',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'code',
        },
        readable: true,
        required: false,
        title: 'code',
        writeable: true,
      },
    ],
    title: 'ProductSortingOption',
    label: 'ProductSortingOption',
    url: 'https://localhost/product_sorting_options',
  },
  {
    '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of CategoryConfiguration resources.',
        label: 'Retrieves the collection of CategoryConfiguration resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
        method: 'POST',
        title: 'Creates a CategoryConfiguration resource.',
        label: 'Creates a CategoryConfiguration resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves CategoryConfiguration resource.',
        label: 'Retrieves CategoryConfiguration resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves CategoryConfiguration resource.',
        label: 'Retrieves CategoryConfiguration resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
        method: 'PUT',
        title: 'Replaces the CategoryConfiguration resource.',
        label: 'Replaces the CategoryConfiguration resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
        method: 'PATCH',
        title: 'Updates the CategoryConfiguration resource.',
        label: 'Updates the CategoryConfiguration resource.',
        returns: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
        },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the CategoryConfiguration resource.',
        label: 'Deletes the CategoryConfiguration resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration/category',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#Category' },
          label: 'category',
        },
        readable: true,
        required: false,
        title: 'category',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration/catalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#Catalog' },
          label: 'catalog',
        },
        readable: true,
        required: false,
        title: 'catalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#CategoryConfiguration/localizedCatalog',
          '@type': 'http://www.w3.org/ns/hydra/core#Link',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          maxCardinality: 1,
          range: { '@id': 'https://localhost/docs.jsonld#LocalizedCatalog' },
          label: 'localizedCatalog',
        },
        readable: true,
        required: false,
        title: 'localizedCatalog',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#CategoryConfiguration/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#CategoryConfiguration/isVirtual',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'isVirtual',
        },
        readable: true,
        required: false,
        title: 'isVirtual',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#CategoryConfiguration/useNameInProductSearch',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#boolean' },
          label: 'useNameInProductSearch',
        },
        readable: true,
        required: false,
        title: 'useNameInProductSearch',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id':
            'https://localhost/docs.jsonld#CategoryConfiguration/defaultSorting',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: {
            '@id': 'https://localhost/docs.jsonld#CategoryConfiguration',
          },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'defaultSorting',
        },
        readable: true,
        required: false,
        title: 'defaultSorting',
        writeable: true,
      },
    ],
    title: 'CategoryConfiguration',
    label: 'CategoryConfiguration',
    url: 'https://localhost/category_configurations',
  },
  {
    '@id': 'https://localhost/docs.jsonld#ExampleDocument',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of ExampleDocument resources.',
        label: 'Retrieves the collection of ExampleDocument resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#ExampleDocument' },
        method: 'POST',
        title: 'Creates a ExampleDocument resource.',
        label: 'Creates a ExampleDocument resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleDocument' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves ExampleDocument resource.',
        label: 'Retrieves ExampleDocument resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleDocument' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the ExampleDocument resource.',
        label: 'Deletes the ExampleDocument resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleDocument/indexName',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleDocument' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'indexName',
        },
        readable: true,
        required: false,
        title: 'indexName',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleDocument/documents',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleDocument' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'documents',
        },
        readable: true,
        required: false,
        title: 'documents',
        writeable: true,
      },
    ],
    title: 'ExampleDocument',
    label: 'ExampleDocument',
    url: 'https://localhost/example_documents',
  },
  {
    '@id': 'https://localhost/docs.jsonld#ExampleProduct',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of ExampleProduct resources.',
        label: 'Retrieves the collection of ExampleProduct resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves ExampleProduct resource.',
        label: 'Retrieves ExampleProduct resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/entity_id',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'entity_id',
        },
        readable: true,
        required: false,
        title: 'entity_id',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        description: 'description',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/description',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          label: 'description',
        },
        readable: true,
        required: false,
        title: 'description',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/type_id',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'type_id',
        },
        readable: true,
        required: false,
        title: 'type_id',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/created_at',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'created_at',
        },
        readable: true,
        required: false,
        title: 'created_at',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/updated_at',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'updated_at',
        },
        readable: true,
        required: false,
        title: 'updated_at',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleProduct/attributes',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleProduct' },
          label: 'attributes',
        },
        readable: true,
        required: false,
        title: 'attributes',
        writeable: true,
      },
    ],
    title: 'ExampleProduct',
    label: 'ExampleProduct',
    url: 'https://localhost/example_products',
  },
  {
    '@id': 'https://localhost/docs.jsonld#ExampleCategory',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of ExampleCategory resources.',
        label: 'Retrieves the collection of ExampleCategory resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
        method: 'POST',
        title: 'Creates a ExampleCategory resource.',
        label: 'Creates a ExampleCategory resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves ExampleCategory resource.',
        label: 'Retrieves ExampleCategory resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
        method: 'PUT',
        title: 'Replaces the ExampleCategory resource.',
        label: 'Replaces the ExampleCategory resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
        method: 'PATCH',
        title: 'Updates the ExampleCategory resource.',
        label: 'Updates the ExampleCategory resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the ExampleCategory resource.',
        label: 'Deletes the ExampleCategory resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleCategory/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleCategory/description',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleCategory' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'description',
        },
        readable: true,
        required: false,
        title: 'description',
        writeable: true,
      },
    ],
    title: 'ExampleCategory',
    label: 'ExampleCategory',
    url: 'https://localhost/example_categories',
  },
  {
    '@id': 'https://localhost/docs.jsonld#ExampleIndex',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of ExampleIndex resources.',
        label: 'Retrieves the collection of ExampleIndex resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/docs.jsonld#ExampleIndex' },
        method: 'POST',
        title: 'Creates a ExampleIndex resource.',
        label: 'Creates a ExampleIndex resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleIndex' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves ExampleIndex resource.',
        label: 'Retrieves ExampleIndex resource.',
        returns: { '@id': 'https://localhost/docs.jsonld#ExampleIndex' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the ExampleIndex resource.',
        label: 'Deletes the ExampleIndex resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
    ],
    supportedProperty: [
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleIndex/name',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleIndex' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'name',
        },
        readable: true,
        required: false,
        title: 'name',
        writeable: true,
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
        description: 'health',
        property: {
          '@id': 'https://localhost/docs.jsonld#ExampleIndex/health',
          '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
          domain: { '@id': 'https://localhost/docs.jsonld#ExampleIndex' },
          range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
          label: 'health',
        },
        readable: true,
        required: false,
        title: 'health',
        writeable: true,
      },
    ],
    title: 'ExampleIndex',
    label: 'ExampleIndex',
    url: 'https://localhost/example_indices',
  },
  {
    '@id': 'https://localhost/Declarative Greeting',
    '@type': 'http://www.w3.org/ns/hydra/core#Class',
    description: 'Description of declarative greetings (description)',
    supportedOperation: [
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves the collection of DeclarativeGreeting resources.',
        label: 'Retrieves the collection of DeclarativeGreeting resources.',
        returns: { '@id': 'http://www.w3.org/ns/hydra/core#Collection' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/CreateAction',
        ],
        expects: { '@id': 'https://localhost/Declarative Greeting' },
        method: 'POST',
        title: 'Creates a DeclarativeGreeting resource.',
        label: 'Creates a DeclarativeGreeting resource.',
        returns: { '@id': 'https://localhost/Declarative Greeting' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/FindAction',
        ],
        method: 'GET',
        title: 'Retrieves DeclarativeGreeting resource.',
        label: 'Retrieves DeclarativeGreeting resource.',
        returns: { '@id': 'https://localhost/Declarative Greeting' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/DeleteAction',
        ],
        method: 'DELETE',
        title: 'Deletes the DeclarativeGreeting resource.',
        label: 'Deletes the DeclarativeGreeting resource.',
        returns: { '@id': 'http://www.w3.org/2002/07/owl#Nothing' },
      },
      {
        '@type': [
          'http://www.w3.org/ns/hydra/core#Operation',
          'http://schema.org/ReplaceAction',
        ],
        expects: { '@id': 'https://localhost/Declarative Greeting' },
        method: 'PUT',
        title: 'Replaces the DeclarativeGreeting resource.',
        label: 'Replaces the DeclarativeGreeting resource.',
        returns: { '@id': 'https://localhost/Declarative Greeting' },
      },
      {
        '@type': 'http://www.w3.org/ns/hydra/core#Operation',
        expects: { '@id': 'https://localhost/Declarative Greeting' },
        method: 'PATCH',
        title: 'Updates the DeclarativeGreeting resource.',
        label: 'Updates the DeclarativeGreeting resource.',
        returns: { '@id': 'https://localhost/Declarative Greeting' },
      },
    ],
    supportedProperty: {
      '@type': 'http://www.w3.org/ns/hydra/core#SupportedProperty',
      description: 'A nice person.',
      property: {
        '@id': 'https://localhost/docs.jsonld#DeclarativeGreeting/name',
        '@type': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#Property',
        domain: { '@id': 'https://localhost/Declarative Greeting' },
        range: { '@id': 'http://www.w3.org/2001/XMLSchema#string' },
        label: 'name',
      },
      readable: true,
      required: true,
      title: 'name',
      writeable: true,
    },
    title: 'DeclarativeGreeting',
    label: 'DeclarativeGreeting',
    url: 'https://localhost/declarative_greetings',
  },
] as IResource[]

export const [, , , resourceWithRef, , resource] = resources

export const [fieldString, , , fieldBoolean, , , , fieldInteger, , , fieldRef] =
  resourceWithRef.supportedProperty

export const api: IApi = resources
